import { APIColumnNames, ExcelColumnNames } from "../constants/columns.constants"
import formatDate from "./formatDate"

const columnMapper = (payload, vendorName) => {
    if (payload.length === 0 || vendorName?.length === 0) {
        return
    }

    const resultArr = []

    try {
        payload.forEach((item) => {
            let temp = {}
            APIColumnNames[vendorName.toLowerCase()].forEach((colName, index) => {
                if (typeof item[ExcelColumnNames[vendorName.toLowerCase()][index]?.toUpperCase()] !== 'undefined') {

                    if (
                        ExcelColumnNames[vendorName.toLowerCase()][index] === 'Account_Activation_Date_Time'
                        || ExcelColumnNames[vendorName.toLowerCase()][index] === 'Application_Date_Time'
                        
                    ) {
                        let date = formatDate(item[ExcelColumnNames[vendorName.toLowerCase()][index]])
                        temp = {
                            ...temp,
                            [colName]: date || ''
                        }
                    } else {         
                        temp = {
                            ...temp,
                            [colName]: item[ExcelColumnNames[vendorName.toLowerCase()][index]] || ''
                        }
                    }

                } else {
                    let currentObjKeys = Object.keys(item)
                    let filteredKeys = currentObjKeys.filter((newK) => {
                        if (ExcelColumnNames[vendorName.toLowerCase()].indexOf(newK) === -1)
                            return newK
                    })
                    filteredKeys.map(uniq => {
                        temp = { ...temp, [uniq] : item[uniq] }
                    })
                }
            })
            resultArr.push(temp)
        })
    
        console.log(payload, vendorName, resultArr);
        return resultArr
    } catch (error) {
        return []
    }
}

export default columnMapper